import { render, staticRenderFns } from "./packagingTaskManagement.vue?vue&type=template&id=2b740410&scoped=true&"
import script from "./packagingTaskManagement.vue?vue&type=script&lang=js&"
export * from "./packagingTaskManagement.vue?vue&type=script&lang=js&"
import style0 from "./packagingTaskManagement.vue?vue&type=style&index=0&id=2b740410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b740410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b740410')) {
      api.createRecord('2b740410', component.options)
    } else {
      api.reload('2b740410', component.options)
    }
    module.hot.accept("./packagingTaskManagement.vue?vue&type=template&id=2b740410&scoped=true&", function () {
      api.rerender('2b740410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/packagingTaskManagement.vue"
export default component.exports